"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInputImage = exports.InputImage = exports.InputImageComponent = exports.InputImageDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var field_container_1 = require("../elements/field-container");
var validator_1 = __importDefault(require("validator"));
var image_banner_1 = require("../elements/image-banner");
var form_field_id_1 = require("../../utils/form-field-id");
var memo = React.memo;
exports.InputImageDefaultProps = {
  autoComplete: 'off'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-grow: 1;\n  "], ["\n    flex-grow: 1;\n  "])))
});
var LayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    width: 100%;\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    width: 100%;\n  "])))
});
var InputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    border: 1px solid ", ";\n    font-weight: 400;\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", " ", " ", ";\n    color: ", ";\n    transition: border-color 0.25s;\n    &:disabled {\n      background-color: #F7F7F7;\n    }\n\n    &:focus {\n      outline: none;\n      border-color: ", "; \n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    display: flex;\n    border: 1px solid ", ";\n    font-weight: 400;\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", " ", " ", ";\n    color: ", ";\n    transition: border-color 0.25s;\n    &:disabled {\n      background-color: #F7F7F7;\n    }\n\n    &:focus {\n      outline: none;\n      border-color: ", "; \n    }\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), theme_1.theme.COLOR('line-mid'), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(16), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3.1), theme_1.theme.COLOR('bold'), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('yellow'), function (props) {
    return !props.valid && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: ", ";\n      border-color: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    "], ["\n      color: ", ";\n      border-color: ", ";\n      &::placeholder {\n        color: ", ";\n      }\n    "])), theme_1.theme.COLOR('error'), theme_1.theme.COLOR('error'), theme_1.theme.COLOR('error'));
  }, function (props) {
    return props.variant === 'gradient' && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      background: linear-gradient(to bottom, #f3f3f3 0%,rgba(255, 255, 255, 0.0) 95%);\n      border: none;\n      font-size: ", ";\n      padding: ", " ", " ", ";\n      border: 2px solid ", ";\n\n      &:focus {\n        border-color: ", ";\n        border-top-color: ", ";\n      }\n    "], ["\n      background: linear-gradient(to bottom, #f3f3f3 0%,rgba(255, 255, 255, 0.0) 95%);\n      border: none;\n      font-size: ", ";\n      padding: ", " ", " ", ";\n      border: 2px solid ", ";\n\n      &:focus {\n        border-color: ", ";\n        border-top-color: ", ";\n      }\n    "])), theme_1.theme.FONT_SIZE(16), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3.5), theme_1.theme.COLOR('line-subtle'), theme_1.theme.COLOR('line-subtle'), theme_1.theme.COLOR('primary'));
  }, function (props) {
    return props.variant === 'gradient' && !props.valid && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      border-color: ", ";\n      border-top-color: ", ";\n    "], ["\n      border-color: ", ";\n      border-top-color: ", ";\n    "])), theme_1.theme.COLOR('line-mid'), theme_1.theme.COLOR('error'));
  })
});
var PreviewStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    box-sizing: border-box;\n    padding: ", ";\n    border: 1px solid ", ";\n    margin-left: ", ";\n    flex-shrink: 0;\n    width: 23%;\n  "], ["\n    box-sizing: border-box;\n    padding: ", ";\n    border: 1px solid ", ";\n    margin-left: ", ";\n    flex-shrink: 0;\n    width: 23%;\n  "])), theme_1.theme.UNIT(1.5), theme_1.theme.COLOR('line-mid'), theme_1.theme.UNIT(6))
});
var ImageBannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Layout: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Container: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Input: styled_components_1.default.input(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  Preview: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), PreviewStyles),
  ImageBanner: (0, styled_components_1.default)(image_banner_1.ImageBanner)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ImageBannerStyles)
};
var InputImageComponent = function (props) {
  var className = props.className,
    field = props.field,
    onChange = props.onChange,
    onBlur = props.onBlur,
    autoComplete = props.autoComplete;
  if (!field) {
    return null;
  }
  var label = field.label,
    description = field.description,
    placeholder = field.placeholder,
    required = field.required,
    name = field.name,
    valid = field.valid,
    value = field.value,
    focus = field.focus,
    errorMessage = field.errorMessage,
    labelRenderer = field.labelRenderer;
  var handleChange = function (event) {
    var target = event.target;
    onChange({
      name: name,
      value: target && target.value
    });
  };
  var handleBlur = function (event) {
    var target = event.target;
    if (onBlur) {
      onBlur({
        name: name,
        value: target && target.value
      });
    }
  };
  var isUrl = validator_1.default.isURL(value);
  return React.createElement(My.Layout, {
    className: className
  }, React.createElement(My.Container, {
    field: field
  }, React.createElement(My.Input, {
    ref: function (input) {
      if (input && focus) {
        input.focus();
        input.select();
      }
    },
    disabled: field.disabled,
    id: (0, form_field_id_1.formFieldId)(field),
    value: value,
    valid: valid,
    autoComplete: autoComplete,
    onChange: handleChange,
    onBlur: handleBlur,
    name: name,
    placeholder: placeholder,
    type: "text"
  })), isUrl && React.createElement(My.Preview, null, React.createElement(My.ImageBanner, {
    fill: true,
    aspectRatio: {
      base: 11 / 6
    },
    image: React.createElement("img", {
      src: value
    })
  })));
};
exports.InputImageComponent = InputImageComponent;
exports.InputImageComponent.defaultProps = exports.InputImageDefaultProps;
exports.InputImage = memo(exports.InputImageComponent);
var createInputImage = function (props) {
  return React.createElement(exports.InputImage, __assign({}, props));
};
exports.createInputImage = createInputImage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;